import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz-trans/client';
import Tracking from '@spotahome/soyuz-tracking';

import { useCookieContext } from '../../context/CookiesContext';

import CloseButton from '../CloseButton';
import Spotahome from '../icons/Spotahome';
import Rating from '../Rating';
import Button from '../Button';

import styles from './AppBanner.module.scss';
import SoyuzAnalytics from "@spotahome/soyuz-analytics";

const COOKIE_ACCEPTED_VALUE = '1';
const COOKIE_EXPIRATION = { days: 1 };
const COOKIE_NAME = 'app-banner-show';
const DEFAULT_OPEN_PATH = 'https://spotahome.app.link/banner_web';
const OPEN_LABEL = 'open';
const CLOSE_LABEL = 'close';

export const AppBanner = ({
  title,
  text,
  openPath,
  onClose,
  onOpen,
  eventCategory,
  eventAction
}) => {
  const cookieManager = useCookieContext();

  const [accepted, setAccepted] = useState(
    cookieManager.getCookie(COOKIE_NAME)
  );

  const setAcceptedCookie = () => {
    cookieManager.setCookie(COOKIE_NAME, COOKIE_ACCEPTED_VALUE, {
      maxAge: COOKIE_EXPIRATION
    });
  };

  const handleOpenBanner = e => {
    e.preventDefault();
    Tracking.ga.sendEvent(eventCategory, eventAction, OPEN_LABEL);
    SoyuzAnalytics.sendGA4Event('app-banner', {category: eventCategory, source: eventAction, action: OPEN_LABEL});
    setAccepted(COOKIE_ACCEPTED_VALUE);
    setAcceptedCookie();
    onOpen(openPath);
  };

  const handleCloseButton = () => {
    Tracking.ga.sendEvent(eventCategory, eventAction, CLOSE_LABEL);
    SoyuzAnalytics.sendGA4Event('app-banner', {category: eventCategory, source: eventAction, action: CLOSE_LABEL});
    setAccepted(COOKIE_ACCEPTED_VALUE);
    setAcceptedCookie();
    onClose();
  };

  return (
    !accepted && (
      <div className={styles['app-banner']}>
        <CloseButton
          size="small"
          className={styles.close}
          onClick={handleCloseButton}
        />
        <a href={openPath} onClick={handleOpenBanner} className={styles.anchor}>
          <div className={styles.logo}>
            <Spotahome />
          </div>
          <div className={styles['text-box']}>
            <div className={styles.title}>
              {title || trans('appbanner.title')}
            </div>
            {text && <div className={styles.text}>{text}</div>}
            <div className={styles.rating}>
              <Rating rating={5} size="small" />
            </div>
          </div>
          <Button color="tertiary-light" className={styles.cta}>
            {trans('appbanner.cta')}
          </Button>
        </a>
      </div>
    )
  );
};

AppBanner.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  openPath: PropTypes.string,
  onClose: PropTypes.func,
  onOpen: PropTypes.func,
  eventCategory: PropTypes.string,
  eventAction: PropTypes.string
};

AppBanner.defaultProps = {
  title: '',
  text: '',
  openPath: DEFAULT_OPEN_PATH,
  onClose: () => {},
  onOpen: path => {
    window.location.href = path;
  },
  eventCategory: 'app-promotion',
  eventAction: 'banner-click'
};

export default AppBanner;
